import Button from "e.sic-platform.webclient/src/components/button/Button";
import { Icon } from "e.sic-platform.webclient/src/icons/Icon";
import useThemeService from "e.sic-platform.webclient/src/services/theme-service/ThemeService";

export default function RunAppButton(props:{onClick: () => void, disabled?: boolean, icon: Icon | undefined}) {
  const { themeClass } = useThemeService();

  return (
    <Button
        id="run-app"
        onClick={props.onClick}
        disabled={props.disabled}
        icon={props.icon}
        className={themeClass(["btn-huge", "run-ai-button"])}
      />
  )
}
